import styled from 'styled-components';
import { Colors } from '../../../../constants/Colors';

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const Subtle = styled.div`
  font-size: 12px;
  color: ${Colors?.commons.darkGray || '#666'};
`;

export const Filters = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 14px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: ${Colors?.commons.black || '#111'};
`;

export const Select = styled.select`
  height: 38px;
  border-radius: 8px;
  padding: 0 10px;
  border: 1px solid ${Colors?.commons.gray || '#ddd'};
  outline: none;
  background: #fff;

  &:focus {
    border-color: ${Colors?.commons.black || '#111'};
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ListItem = styled.div`
  border: 1px solid ${Colors?.commons.gray || '#e9e9e9'};
  border-radius: 10px;
  padding: 12px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Name = styled.div`
  font-weight: 800;
  color: ${Colors?.commons.black || '#111'};
  word-break: break-word;
`;

export const Meta = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${Colors?.commons.darkGray || '#666'};
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const IconButton = styled.button<{ $danger?: boolean }>`
  height: 32px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid ${({ $danger }) => ($danger ? (Colors?.secondary[100] || '#d00') : (Colors?.commons.gray || '#ddd'))};
  background: #fff;
  color: ${({ $danger }) => ($danger ? (Colors?.secondary[100] || '#d00') : (Colors?.commons.black || '#111'))};
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const InlineLinkBox = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
`;

export const InlineInput = styled.input`
  height: 38px;
  min-width: 260px;
  border-radius: 8px;
  padding: 0 10px;
  border: 1px solid ${Colors?.commons.gray || '#ddd'};
  outline: none;

  &:focus {
    border-color: ${Colors?.commons.black || '#111'};
  }
`;

export const Empty = styled.div`
  margin-top: 16px;
  padding: 14px;
  border: 1px dashed ${Colors?.commons.gray || '#ddd'};
  border-radius: 10px;
  color: ${Colors?.commons.darkGray || '#666'};
  font-size: 12px;
`;
